import Card, { ICardProps } from "./Card";

interface ICardWithImage extends ICardProps {
    title: string;
    image: string | any;
    isLoading?: boolean;
}

const CardWithImage: React.FC<ICardWithImage> = ({
    title,
    children,
    image,
    isLoading = false,
    onClick,
    options,
}) => {
    const content = isLoading ? (
        <Card>
            <div role="status" className="animate-pulse flex md:items-center">
                <div className="flex justify-center items-center w-28 h-28 bg-gray-300 rounded md:w-72 md:h-36 dark:bg-gray-700">
                    <svg
                        className="w-12 h-12 text-gray-200"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        fill="currentColor"
                        viewBox="0 0 640 512"
                    >
                        <path d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z"></path>
                    </svg>
                </div>
                <div className="w-6/12 md:w-full ml-4 mt-8">
                    <div className="h-6 bg-gray-200 rounded-full dark:bg-gray-700 w-24 md:w-48 mb-4"></div>
                    <div className="h-3 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[160px] mb-2.5"></div>
                </div>
                <span className="sr-only">Loading...</span>
            </div>
        </Card>
    ) : (
        <Card options={options} onClick={onClick}>
            {image ? (
                <img
                    className="object-cover h-auto w-28 md:w-40 rounded-none rounded-l-lg"
                    src={image}
                    alt=""
                />
            ) : (
                <div className="flex justify-center items-center w-44 min-w-28 h-28 bg-gray-300 rounded md:w-40 md:h-36 dark:bg-gray-700">
                    <svg
                        className="w-12 h-12 text-gray-200"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        fill="currentColor"
                        viewBox="0 0 640 512"
                    >
                        <path d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z"></path>
                    </svg>
                </div>
            )}
            <div className="flex flex-col justify-between p-4 w-[66%] leading-normal overflow-hidden">
                <h5 className="mb-2 text-md md:text-xl font-bold tracking-tight text-gray-900 dark:text-white break-words text-ellipsis overflow-hidden line-clamp-2">
                    {title}
                </h5>
                {children}
            </div>
        </Card>
    );

    return content;
};

export default CardWithImage;
